export default __webpack_public_path__ + "static/gearsTactics-ada84156b1f104bbf94eb6d39cadbbc5.jpg";